(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["argile-collection-gallery"] && !Shopify.designMode) return;
  try {
    
  /*
   * Galerie — « Voir plus » révèle le second groupe d'images.
   * Délégation au document : l'éditeur de thème re-rend la section sans repasser ici.
   * Tout l'affichage est décidé par le CSS à partir de `data-gallery-expanded` ; ce
   * script ne fait que basculer cet attribut.
   */
  if (!window.__argileGalleryBound) {
    window.__argileGalleryBound = true;

    document.addEventListener('click', (event) => {
      const btn = event.target.closest && event.target.closest('[data-gallery-reveal]');
      if (!btn) return;

      const galerie = btn.closest('.argile-collection-gallery');
      if (!galerie) return;

      galerie.setAttribute('data-gallery-expanded', 'true');

      // AUCUN DÉFILEMENT PROGRAMMÉ, volontairement. Le second groupe s'insère juste
      // au-dessus des boutons : en désactivant l'ancrage de défilement (voir le CSS), il
      // apparaît exactement là où se trouvait le bouton cliqué, donc sous les yeux. Un
      // `scrollIntoView` a été essayé le 2026-08-04 pour « bien faire » : il entrait en
      // concurrence avec le navigateur et produisait des sauts de plusieurs milliers de
      // pixels selon le moment du clic. Le comportement naturel est le bon.
      const groupe = galerie.querySelector('[data-gallery-second]');
      if (!groupe) return;

      // Le bouton cliqué disparaît : sans ce déplacement, la navigation au clavier
      // repartirait du début du document. `preventScroll` pour ne rien déplacer.
      groupe.focus({ preventScroll: true });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /*
   * Argile — bouton « Partager » de la bande CTA insérée dans la grille.
   * Délégation au document : le filtrage natif re-rend la grille (et donc le bouton)
   * sans repasser par ce script, donc on n'attache rien au bouton lui-même.
   * Le bouton n'est visible que si le JS est actif — c'est le CSS qui s'en charge
   * (`@media (scripting: enabled)`), sans observateur ni révélation à la main.
   */
  if (!window.__argileShareBound) {
    window.__argileShareBound = true;

    document.addEventListener('click', async (event) => {
      const btn = event.target.closest && event.target.closest('[data-argile-share]');
      if (!btn) return;

      const shareData = {
        title: btn.getAttribute('data-share-title') || document.title,
        url: window.location.href,
      };

      if (navigator.share) {
        // AbortError = l'utilisateur a fermé la feuille de partage : rien à signaler.
        try {
          await navigator.share(shareData);
        } catch (error) {
          if (error && error.name !== 'AbortError') console.error(error);
        }
        return;
      }

      const label = btn.querySelector('[data-argile-share-label]');
      if (!label) return;
      try {
        await navigator.clipboard.writeText(shareData.url);
        const original = label.textContent;
        label.textContent = label.getAttribute('data-copied-label') || 'Lien copié';
        setTimeout(() => {
          label.textContent = original;
        }, 2000);
      } catch (error) {
        console.error(error);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
